module.exports = __webpack_public_path__ + "da752dea4ad1f4746cf430a3a3bdbd08.svg";